var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oil-requirement"},[_c('HeatingStatistics',{attrs:{"city":_vm.city,"zipcode":_vm.zipcode,"oilRequirements":_vm.oilRequirements}}),_vm._v(" "),_c('HeatingOilTable',{attrs:{"oilRequirements":_vm.oilRequirements}}),_vm._v(" "),_c('Footnotes'),_vm._v(" "),_c('EnergyLegend')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }